import { FormLabel, FormControlLabel, Radio, RadioGroup, Box, Paper } from "@mui/material";

const TrueFalseOptions = ({ value, onChange }) => {
  const isTrue = value === true || value === "true";
  return (
    <Box>
      <FormLabel sx={{ fontWeight: 600, color: "#444", mb: 1.5, display: "block" }}>
        Correct Answer
      </FormLabel>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          display: "inline-flex",
          gap: 3,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          background: "#fafafa",
        }}
      >
        <RadioGroup
          row
          value={isTrue ? "true" : "false"}
          onChange={(e) => onChange(e.target.value === "true")}
        >
          <FormControlLabel
            value="true"
            control={
              <Radio
                sx={{
                  color: isTrue ? "#4caf50" : "#999",
                  "&.Mui-checked": { color: "#4caf50" },
                }}
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: isTrue ? "#4caf50" : "#ddd" }} />
                <Box sx={{ fontWeight: 500, color: isTrue ? "#2e7d32" : "#666" }}>True</Box>
              </Box>
            }
          />
          <FormControlLabel
            value="false"
            control={
              <Radio
                sx={{
                  color: !isTrue ? "#f44336" : "#999",
                  "&.Mui-checked": { color: "#f44336" },
                }}
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: !isTrue ? "#f44336" : "#ddd" }} />
                <Box sx={{ fontWeight: 500, color: !isTrue ? "#c62828" : "#666" }}>False</Box>
              </Box>
            }
          />
        </RadioGroup>
      </Paper>
    </Box>
  );
};

export default TrueFalseOptions;
